import ValidatedField, { type ValidatedFieldProps } from "./ValidatedField";
import { WeekDayPicker } from "../weekDayPicker";
import { type WeekDayPickerProps } from "../weekDayPicker/WeekDayPicker";
import { type FormikProps } from "formik";

export interface WeekDayPickerFieldProps extends Omit<ValidatedFieldProps, "children"> {
  onBlur?: (propertyName: string) => void;
}

export type WeekDayPickerFieldPropsAll<T> = WeekDayPickerProps & WeekDayPickerFieldProps & FormikProps<T>;

export default function WeekDayPickerField<T>(props: WeekDayPickerFieldPropsAll<T>) {
  const handleChange = async (data: number[]) => {
    const { propertyName, setFieldTouched, setFieldValue, onBlur } = props;
    setFieldTouched(propertyName, true, false);
    await (setFieldValue(propertyName, data) as unknown as Promise<void>);
    onBlur?.(propertyName);
  };

  return (
    <ValidatedField {...props}>
      <WeekDayPicker {...props} onChange={handleChange} />
    </ValidatedField>
  );
}
